// Google Maps reports billing and WebGL failures as cross-origin "Script error."
// The dev overlay treats that as an app crash. Stop it before the overlay's
// bubble listener runs. Real app errors still have an Error object.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (event) => {
      const message = String(event?.message || event?.error?.message || "");
      const source = String(event?.filename || "");
      const fromMaps =
        /3d context|BillingNotEnabled|maps\.googleapis|maps\.gstatic/i.test(
          `${message} ${source}`,
        );
      const crossOriginScript = message === "Script error." && !event?.error;
      if (!fromMaps && !crossOriginScript) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
}
